import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { Header, Footer, PdfPreview } from "~/components/blocks";
import { HeroBanner } from "~/components/sections";
import { Breadcrumb, Margin, Title } from "~/components/elements";
import * as S from "./styles";
import pdfRegulamento from "~/assets/pdf/Regulamento_0202409319_VB.pdf";
import pdfConcurso from "~/assets/pdf/Regulamento_0202409318_Concurso.pdf";
import imgPdfRegulamento from "~/assets/img/pdf1.png";
import imgPdfConcurso from "~/assets/img/pdf2.png";

export default function Regulation() {

  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  const navBreadcrumb = [
    {
      text: "Início",
      link: "/",
    },
    {
      text: "Regulamento",
      link: "/regulamento",
    },
  ];


  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Regulamento</title>
      </Helmet>

      <Header />

      <HeroBanner />

      <S.StyledMotionDiv>
        <div className="div">
          <motion.div
            variants={animations}
            className="single"
            initial="exit"
            animate="enter"
            exit="exit"
            id="conteudo"
          >
            <Margin mb={6}>
              <Breadcrumb navBreadcrumb={navBreadcrumb} />
            </Margin>

            <S.PdfPreviewContainer>
              <Margin mb={6}>
                <S.PdfTitle>
                  <Title as="4" levelDesktop="5" level="4" primary>
                    <strong>Regulamento da Promoção Johnson's Baby</strong>
                  </Title>
                </S.PdfTitle>
              </Margin>

              <S.PdfPreview>
                <S.PdfDownload>
                1. Faça o download do <u><strong><a href={pdfRegulamento} download>Regulamento da Promoção Johnson's Baby aqui</a></strong></u>.
                </S.PdfDownload>
                <PdfPreview fileSrc={pdfRegulamento} imageSrc={imgPdfRegulamento} alt="Regulamento da Promoção Johnson's Baby" showDownload={false}/>
              </S.PdfPreview>
            </S.PdfPreviewContainer>


            <S.PdfPreviewContainer>
              <Margin mt={2} mb={6}>
                <S.PdfTitle>
                  <Title as="4" levelDesktop="5" level="4" primary>
                    <strong>Regulamento do Concurso Johnson's Baby</strong>
                  </Title>
                </S.PdfTitle>
              </Margin>

              <S.PdfPreview>
                <S.PdfDownload>
                  2. Faça o download do <u><strong><a href={pdfConcurso} download>Regulamento do Concurso Johnson's Baby aqui</a></strong></u>.
                </S.PdfDownload>
                <PdfPreview fileSrc={pdfConcurso} imageSrc={imgPdfConcurso} alt="Regulamento do Concurso Johnson's Baby" showDownload={false}/>
              </S.PdfPreview>
            </S.PdfPreviewContainer>
          </motion.div>
        </div>
      </S.StyledMotionDiv>
      <Footer />
    </>
  );
}
